import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { provideState, StoreModule } from '@ngrx/store';

import { DialogComponent } from './dialog.component';
import { dialogReducer } from './dialog.reducer';
import { FEATURE_NAME } from './dialog.constant';
import { NgrxDialogCloseDirective } from './modules';

@NgModule({
  imports: [
    // StoreModule.forFeature(FEATURE_NAME, dialogReducer)
  ]
})
export class VshcDialogRootModule {
}

@NgModule({
  declarations: [ DialogComponent ],
  imports: [
    CommonModule,
    MatDialogModule
  ],
  exports: [
    DialogComponent

  ]
})
export class VshcDialogModule {
  static forRoot(): ModuleWithProviders<VshcDialogRootModule> {
    return {
      ngModule: VshcDialogRootModule,
      providers: [
        provideState(FEATURE_NAME, dialogReducer)
      ]
    };
  }
}
